import React from "react";

// Components
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";

// Assets
import "~/assets/sass/pages/common/settingPage/settingPage.scss";
import "~/assets/sass/pages/common/settingPage/Modal/settingModal.scss";

import { useTranslation } from "react-i18next";

const EvalListModal = ({
	settingDetail,
	evalCategories,
	evaluateCategoryModal,
	setEvaluateCategoryModal,
}) => {
	const { t } = useTranslation();

	return (
		<ModalTemplate
			modalState={evaluateCategoryModal}
			setModalToggle={setEvaluateCategoryModal}
			title={t("pages.round.RoundSetting.evaluateListModal.EvalListModal.evaluationItem")}
			width={1100}
			height={680}
			className="setting-summary"
		>
			<div className="modal-content">
				<div className="side-content">
					<h3>{settingDetail.title}</h3>
				</div>
				<section className="c__card">
					<div className="table-head">
						<div className="th main-category">{t("pages.round.RoundSetting.evaluateListModal.EvalListModal.item")}</div>
						<div className="th sub-category">{t("pages.round.RoundSetting.evaluateListModal.EvalListModal.evaluateitem")}</div>
						<div className="th weight">{t("pages.round.RoundSetting.evaluateListModal.EvalListModal.ratio")}</div>
					</div>
					<ul className="setting-summary-table">
						{evalCategories.map((d) => (
							<li className="tr" key={d.idx}>
								<div className="td main-category">{d.title}</div>
								<div className="td sub-category">
									{d.Item.map((d) => (
										<p key={d.idx}>{d.content}</p>
									))}
								</div>
								<div className="td weight" data-unit="%">
									{d.weight}
								</div>
							</li>
						))}
					</ul>
				</section>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() => setEvaluateCategoryModal(false)}
				>
					{t("pages.round.RoundSetting.evaluateListModal.EvalListModal.check")}
				</button>
			</div>
		</ModalTemplate>
	);
};

export default EvalListModal;
